import { createRoot } from "react-dom/client";
import { createElement } from "react";
import components from "./components";

function mountAll() {
  document.querySelectorAll("[data-react-component]").forEach((el) => {
    const name = el.dataset.reactComponent;
    const Component = components[name];
    if (!Component) {
      console.error(`[mount] unknown component: ${name}`);
      return;
    }
    let props = {};
    const raw = el.dataset.props;
    if (raw) {
      try {
        props = JSON.parse(raw);
      } catch (e) {
        console.error(`[mount] bad data-props JSON on ${name}:`, e);
        return;
      }
    }
    createRoot(el).render(createElement(Component, props));
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", mountAll);
} else {
  mountAll();
}
